export default "__VITE_ASSET__DtKQ2Ijd__"